import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzButtonSize, SzButtonType, SzButtonVariant } from './sz-button.types';

@Component({
  selector: 'sz-button',
  templateUrl: './sz-button.component.html',
  styleUrls: ['./sz-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzButtonComponent {
  readonly variant: InputSignal<SzButtonVariant> = input<SzButtonVariant>('primary');
  readonly size: InputSignal<SzButtonSize> = input<SzButtonSize>('default');
  readonly type: InputSignal<SzButtonType> = input<SzButtonType>('button');
  readonly disabled: InputSignal<boolean> = input<boolean>(false);
  readonly fullWidth: InputSignal<boolean> = input<boolean>(false);
}
